import { BaseApiService } from './BaseApiService';

export interface InventoryCheckResult {
  productId: number;
  productName: string;
  productCode: string;
  currentInventory: number;
  minimumThreshold: number;
  targetThreshold: number;
  existingProductionOrders: number;
  requiredProduction: number;
  productionOrderCreated?: number;
  action: 'no_action' | 'production_order_created' | 'sufficient_existing_orders';
  reason: string;
}

export interface InventoryCheckSummary {
  totalProductsChecked: number;
  productsBelowMinimum: number;
  productionOrdersCreated: number;
  totalCasesToProduce: number;
  results: InventoryCheckResult[];
}

export interface InventoryCheckPreviewProduct {
  product_id: number;
  product_name: string;
  product_code: string;
  current_inventory: number;
  threshold_minimum_cases: number;
  threshold_baseline_cases: number;
  threshold_ideal_cases: number;
  existing_production_orders: number;
  would_create_cases: number;
}

class InventoryCheckService extends BaseApiService {
  /**
   * Get preview of products that would be affected by inventory check
   */
  async getInventoryCheckPreview(): Promise<InventoryCheckPreviewProduct[]> {
    const response = await this.get<{ success: boolean; data: InventoryCheckPreviewProduct[] }>(
      '/inventory/check/preview'
    );
    return response.data;
  }

  /**
   * Run inventory check and create production orders
   */
  async runInventoryCheck(): Promise<InventoryCheckSummary> {
    const response = await this.post<{ success: boolean; data: InventoryCheckSummary }>(
      '/inventory/check/run'
    );
    return response.data;
  }
}

export const inventoryCheckService = new InventoryCheckService();
export default inventoryCheckService;
